export enum CheckoutStep {
    CONTACT_DETAILS = 0,
    DELIVERY = 1,
    PAYMENT = 2,
}

export enum ShippingMethodTypes {
    CLICK_AND_COLLECT = "CC",
    TRY_AND_BUY = "CR",
    HOME_DELIVERY = "HD",
    JAPAN_CLICK_AND_COLLECT = "JP-CC",
    PARCEL_SHOP = "PS",
}

export interface ShippingMethod {
    key: string;
    marketKey: string;
    type: ShippingMethodTypes;
}

export const DELIVERY_METHODS_DICTIONARY: Record<string, ShippingMethod[]> = {
    "jp.ecco.com": [{ key: "CC", marketKey: "JP-CC", type: ShippingMethodTypes.CLICK_AND_COLLECT }],
};

export type TPaymentMethods = {
    name: string;
    type: string;
    brands?: string[];
    configuration?: object;
    _Configuration?: {
        // GooglePay uses gatewayMerchantId
        gatewayMerchantId?: string;
        // ApplePay uses merchantId
        merchantId?: string;
        merchantName: string;
    };
};

export type TPaymentResponse = {
    resultCode: string;
    action?: string;
};

export type TOrderResponse = {
    paymentMethod: string;
    orderId?: string;
    resultCode?: string;
    orderState?: object;
    message?: string;
    orderNumber?: string;
};

export type TPaymentStatus = "Successful" | "NoPayment" | "Failed";
